import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxMaskPipe } from 'ngx-mask';
import { catchError } from "rxjs";
import { Observable } from 'rxjs/dist/types';
import { DynamicModalRequestService } from 'src/app/shared/dynamic-modal/dynamic-modal-request.service';
import { IDynamicPanel, OptionalParams } from 'src/app/shared/dynamic-panel/panel-interface';
import { FeatureAction } from 'src/app/shared/model/feature';
import { FormatCnpjPipe } from 'src/app/shared/pipes/formata-cnpj.pipe';
import { FormatCpfPipe } from 'src/app/shared/pipes/formata-cpf.pipe';
import { ScopedMessageService } from 'src/app/shared/services/scoped-message.service';
import { AgenciaDto } from '../../models/agencia-dto';
import { BancoDto } from '../../models/banco-dto';
import { CondicaoDocumentoDto, CondicaoDocumentoEnum } from '../../models/condicao-documento-dto';
import { ModalidadeArrecadacaoDto } from '../../models/modalidade-arrecadacao-dto';
import { NaturezaDto } from '../../models/natureza-dto';
import { FaixaArrecadacao, NISemDV, NivelPesquisa, ParametrosPesquisaPagamento, PeriodoArrecadacao, TipoNivelPesquisa } from '../../models/parametros-pesquisa';
import { ReceitaDto } from '../../models/receita-dto';
import { RegiaoDto } from '../../models/regiao-dto';
import { TipoDocumentoDto } from '../../models/tipo-documento-dto';
import { TipoNIRDOC } from '../../models/tipo-ni-rdoc';
import { UnidadeAdministrativaDto } from '../../models/unidade-administrativa-dto';
import { PagamentoService } from '../../services/pagamento.service';
import { ConsultaPagamentosComponent } from '../consulta-pagamentos/consulta-pagamentos.component';


@Component({
  templateUrl: './filtros-pesquisa-pagamento.component.html',
  styleUrls: ['./filtros-pesquisa-pagamento.component.css'],
  providers: [NgxMaskPipe, ScopedMessageService]
})
export class FiltrosPesquisaPagamentoComponent implements IDynamicPanel {

  @ViewChild('templateModalErro') public templateModalErro: TemplateRef<Element>;

  titulo = 'Pagamento - Consultar - Filtros de Pesquisa';

  public condicoesDocumentoArrecadacao: CondicaoDocumentoDto[] = [];

  public tiposDocumentoArrecadacao$: Observable<TipoDocumentoDto[]>;
  public receitas$: Observable<ReceitaDto[]>;
  public bancos$: Observable<BancoDto[]>;
  public agencias$: Observable<AgenciaDto[]>;
  public modalidadesArrecadacao$: Observable<ModalidadeArrecadacaoDto[]>;
  public naturezasDocumentoArrecadacao$: Observable<NaturezaDto[]>;
  public delegacias$: Observable<UnidadeAdministrativaDto[]>;
  public regioes$: Observable<RegiaoDto[]>;

  public atendimento: boolean = false;

  numeroPagamentoName = 'numeroPagamento';
  numeroDocumentoName = 'numeroDocumento';
  tipoDocumentoName = 'tipoDocumento';
  condicaoDocumentoName = 'condicaoDocumento';
  dataArrecadacaoInicioName = 'dataArrecadacaoInicio';
  dataArrecadacaoFimName = 'dataArrecadacaoFim';
  cpfSemDvName = 'cpfSemDv';
  cnpjSemDvName = 'cnpjSemDv';
  niInvalidoName = 'niInvalido';
  bancoName = 'banco';
  agenciaName = 'agencia';
  modalidadeArrecadacaoName = 'modalidadeArrecadacao';
  debitosNaoEfetivadosDaraOnlineName = 'debitosNaoEfetivadosDaraOnline';
  faixaInicioName = 'faixaInicio';
  faixaFimName = 'faixaFim';
  naturezaDocumentoName = 'naturezaDocumento';
  receitaName = 'receita';
  tipoPesquisaName = 'tipoPesquisa';
  delegaciaName = 'delegacia';
  regiaoName = 'regiao';
  periodoFixoName = 'periodoFixo';

  public TipoNivelPesquisa = TipoNivelPesquisa;

  public scopeId: string;
  formGroup: FormGroup;
  initError: Error;
  ni: string;
  filtroColapsado = false;
  exibeResultado = false;
  parametros: ParametrosPesquisaPagamento;

  currencyMaskOptions = {
    thousands: '.',
    decimal: ',',
    prefix: '',
    allowNegative: false,
    nullable: true,
    min: null,
    max: null
  };

  private modalRef: BsModalRef;

  private dataHoje = new Date();

  private readonly customErrorHandler = (contexto: string) => catchError(() => {
    this.scopedMessageService.showError(
      `Não foi possível carregar as informações do campo "${contexto}". Tente novamente em alguns instantes.`,
      "Erro ao obter os dados da caixa de seleção!"
    );
    return [];
  });

  constructor(
    private formBuilder: FormBuilder,
    private pagamentoService: PagamentoService,
    private dynamicModalRequest: DynamicModalRequestService,
    private maskPipe: NgxMaskPipe,
    private bsModalService: BsModalService,
    private scopedMessageService: ScopedMessageService,
  ) { }

  public init(ni: string = '', params?: OptionalParams): void {
    this.scopeId = this.scopedMessageService.scopeId;
    this.ni = ni;

    if (params?.atendimento) {
      this.atendimento = true;
    }

    if (this.ni) {
      this.titulo = `${this.titulo} - ${this.ni.length === 11 ?
        FormatCpfPipe.formatCPF(this.ni) :
        FormatCnpjPipe.formatCNPJ(this.ni)}`;
    }

    this.formGroup = this.formBuilder.group({
      numeroPagamento: [],
      numeroDocumento: [],
      tipoDocumento: [],
      condicaoDocumento: [],
      dataArrecadacaoInicio: [],
      dataArrecadacaoFim: [],
      cpfSemDv: [],
      cnpjSemDv: [],
      niInvalido: [],
      banco: [],
      agencia: [],
      modalidadeArrecadacao: [],
      faixaInicio: [null],
      faixaFim: [null],
      naturezaDocumento: [],
      receita: [],
      tipoPesquisa: [],
      pesquisaDelegaciaCodigo: [],
      pesquisaRegiaoCodigo: [],
      delegacia: [],
      regiao: [],
      debitosNaoEfetivadosDaraOnline: [],
      periodoFixo: [],
    });

    this.onFormChanges();
    this.preencherCpfOuCnpj();
    this.obterCondicaoDocumentoArrecadacao();
    this.configurarCamposSelecao();
  }

  public configurarCamposSelecao(): void {
    this.tiposDocumentoArrecadacao$ = this.pagamentoService.obterTiposDocumentoArrecadacao().pipe(this.customErrorHandler("Tipo do Documento"));
    this.receitas$ = this.pagamentoService.obterReceitas().pipe(this.customErrorHandler("Receita"));
    this.bancos$ = this.pagamentoService.obterBancos().pipe(this.customErrorHandler("Banco"));
    this.modalidadesArrecadacao$ = this.pagamentoService.obterModalidadesArrecadacao().pipe(this.customErrorHandler("Modalidade de Arrecadação"));
    this.naturezasDocumentoArrecadacao$ = this.pagamentoService.obterNaturezasDocumentoArrecadacao().pipe(this.customErrorHandler("Natureza do Documento"));
    this.delegacias$ = this.pagamentoService.obterDelegacias().pipe(this.customErrorHandler("Delegacia"));
    this.regioes$ = this.pagamentoService.obterRegioes().pipe(this.customErrorHandler("Regional"));
  }

  public onSubmit(): void {
    this.parametros = {
      numeroPagamento: this.numeroPagamento,
      numeroDocumento: this.numeroDocumento,
      tipoDocumento: this.tipoDocumento,
      condicaoDocumento: this.condicaoDocumento,
      periodoArrecadacao: this.periodoArrecadacao,
      niSemDv: this.niSemDv,
      banco: this.banco,
      agencia: this.agencia,
      faixaArrecadacao: this.faixaArrecadacao,
      naturezaDocumento: this.naturezaDocumento,
      receita: this.receita,
      nivelPesquisa: this.nivelPesquisa,
      modalidadeArrecadacao: this.modalidadeArrecadacao,
      debitosNaoEfetivadosDaraOnline: this.debitosNaoEfetivadosDaraOnline,
    } as ParametrosPesquisaPagamento;

    if (this.camposNivelPesquisaEhInvalido(this.parametros.nivelPesquisa)) {
      this.abrirModalErroNivelPesquisa()
      return;
    }

    if (this.ni) {
      this.exibeResultado = true;
      this.filtroColapsado = true;
    } else {
      this.exibeResultado = false;
      const feature = new FeatureAction();
      feature.class = ConsultaPagamentosComponent;
      feature.parametros = {
        parametrosPesquisa: this.parametros,
        atendimento: false
      };
      this.dynamicModalRequest.abrirModal(feature);
    }
  }

  public colapsar(valor: boolean): void {
    this.filtroColapsado = valor;
  }

  public receitaLabelFunction(receita: ReceitaDto): string {
    return receita == null ? "" : `${receita.codigo.toString().padStart(4, '0')} - ${receita.descricao}`;
  }

  public bancoLabelFunction(banco: BancoDto): string {
    return banco == null ? "" : `${banco.codigo.toString().padStart(3, '0')} ${banco.nome}`;
  }

  public agenciaLabelFunction(agencia: AgenciaDto): string {
    return agencia == null ? "" : `${agencia.codigo.toString().padStart(4, '0')} ${agencia.nome}`;
  }

  public delegaciaLabelFunction(delegacia: UnidadeAdministrativaDto): string {
    return delegacia == null ? "" : `${delegacia.codigo.toString().padStart(7, '0')} - ${delegacia.nome}`;
  }

  public regiaoLabelFunction(regiao: RegiaoDto): string {
    return regiao == null ? "" : `${regiao.descricao} Região Fiscal`;
  }

  public tipoDocumentoLabelFunction(tipoDocumento: TipoDocumentoDto): string {
    return tipoDocumento?.nomeAbreviado ?? "";
  }

  public descricaoLabelFunction(item: { descricao: string }): string {
    return item?.descricao ?? "";
  }

  private get numeroPagamento(): string {
    const numeroPagamento = this.formGroup.get(this.numeroPagamentoName).value as string;
    return numeroPagamento === "" ? undefined : numeroPagamento;
  }

  private get numeroDocumento(): string {
    const numeroDocumento = this.formGroup.get(this.numeroDocumentoName).value as string;
    return numeroDocumento === "" ? undefined : numeroDocumento;
  }

  private get periodoArrecadacao(): PeriodoArrecadacao {
    const dataInicial = this.formGroup.get(this.dataArrecadacaoInicioName).value as Date;
    const dataFinal = this.formGroup.get(this.dataArrecadacaoFimName).value as Date;
    return { dataInicial, dataFinal } as PeriodoArrecadacao;
  }

  private get periodoFixo(): number {
    return this.formGroup.get(this.periodoFixoName).value as number;
  }

  private get niSemDv(): NISemDV {
    const niInvalido = Boolean(this.formGroup.get(this.niInvalidoName).value);

    const cpf = this.formGroup.get(this.cpfSemDvName).value as string;
    if (cpf) {
      const cpfUnmasked = this.unmaskNi(cpf);
      const tipoNi = niInvalido ? TipoNIRDOC.NI_INVALIDO : TipoNIRDOC.CPF;
      return { ni: cpfUnmasked, tipoNi: tipoNi, niInvalido } as NISemDV;
    }

    const cnpj = this.formGroup.get(this.cnpjSemDvName).value as string;
    if (cnpj) {
      const cnpjUnmasked = this.unmaskNi(cnpj);
      const tipoNi = niInvalido ? TipoNIRDOC.NI_INVALIDO : TipoNIRDOC.CNPJ;
      return { ni: cnpjUnmasked, tipoNi: tipoNi, niInvalido } as NISemDV;
    }
  }

  private get faixaArrecadacao(): FaixaArrecadacao {
    const valorInicial = this.formGroup.get(this.faixaInicioName).value as number;
    const valorFinal = this.formGroup.get(this.faixaFimName).value as number;
    return { valorInicial, valorFinal } as FaixaArrecadacao;
  }

  private get naturezaDocumento(): NaturezaDto {
    return this.formGroup.get(this.naturezaDocumentoName).value;
  }

  private get nivelPesquisa(): NivelPesquisa {
    const tipoPesquisa = this.formGroup.get(this.tipoPesquisaName).value as TipoNivelPesquisa;
    const codigoDelegacia = (this.formGroup.get(this.delegaciaName).value as UnidadeAdministrativaDto)?.codigo;
    const codigoRegiao = (this.formGroup.get(this.regiaoName).value as RegiaoDto)?.codigo;

    switch (tipoPesquisa) {
      case TipoNivelPesquisa.DELEGACIA:
        return { tipo: tipoPesquisa, valor: codigoDelegacia } as NivelPesquisa;

      case TipoNivelPesquisa.REGIAO:
        return { tipo: tipoPesquisa, valor: codigoRegiao } as NivelPesquisa;

      case TipoNivelPesquisa.BRASIL:
        return { tipo: tipoPesquisa } as NivelPesquisa;
    }
  }

  /********** Incluído pela demanda VIA-3571522 - COGEA 12428/2022 **********/
  private get tipoDocumento(): TipoDocumentoDto {
    return this.formGroup.get(this.tipoDocumentoName).value;
  }

  private get condicaoDocumento(): CondicaoDocumentoDto {
    return this.formGroup.get(this.condicaoDocumentoName).value;
  }
  /****************************************************************************/

  /*********** Alterado pela demanda VIA-3571522 - COGEA 12428/2022 ***********/
  private get receita(): ReceitaDto {
    return this.formGroup.get(this.receitaName).value;
  }

  private get banco(): BancoDto {
    return this.formGroup.get(this.bancoName).value;
  }

  private get agencia(): AgenciaDto {
    return this.formGroup.get(this.agenciaName).value;
  }

  private get modalidadeArrecadacao(): ModalidadeArrecadacaoDto {
    return this.formGroup.get(this.modalidadeArrecadacaoName).value;
  }

  private get debitosNaoEfetivadosDaraOnline(): boolean {
    if (this.condicaoDocumento.codigo != CondicaoDocumentoEnum.EMITIDO) {
      return null;
    }

    return this.formGroup.get(this.debitosNaoEfetivadosDaraOnlineName).value ? true : null;
  }

  private get delegacia(): UnidadeAdministrativaDto {
    return this.formGroup.get(this.delegaciaName).value;
  }

  private get regiao(): RegiaoDto {
    return this.formGroup.get(this.regiaoName).value;
  }
  /****************************************************************************/

  private obterCondicaoDocumentoArrecadacao(): void {
    this.pagamentoService.obterCondicoesDocumentoArrecadacao().subscribe({
      next: (response) => {
        this.condicoesDocumentoArrecadacao = response;
        this.formGroup.get(this.condicaoDocumentoName).setValue(this.condicoesDocumentoArrecadacao[0]);
      },
      error: () => {
        this.formGroup.disable({ emitEvent: false });
        this.scopedMessageService.showError(
          'Feche e abra novamente a tela de consulta de pagamentos.',
          'Erro ao obter os dados da Condição do Documento!'
        );
      }
    });
  }

  private unmaskNi(ni: string): string {
    return ni.replace(/[^\d]+/g, '');
  }

  private preencherCpfOuCnpj(): void {
    if (this.atendimento) {
      if (this.ni.length === 11) {
        const cpfSemDV = this.ni.slice(0, 9);
        const cpfFormatado = this.maskPipe.transform(cpfSemDV, '999.999.999');
        this.formGroup.get(this.cpfSemDvName).setValue(cpfFormatado, { emitEvent: false });
      } else {
        const cnpjSemDV = this.ni.slice(0, 12);
        const cnpjFormatado = this.maskPipe.transform(cnpjSemDV, '99.999.999/9999');
        this.formGroup.get(this.cnpjSemDvName).setValue(cnpjFormatado, { emitEvent: false });
      }

      this.formGroup.get(this.cpfSemDvName).disable({ emitEvent: false });
      this.formGroup.get(this.cnpjSemDvName).disable({ emitEvent: false });
      this.formGroup.get(this.niInvalidoName).disable({ emitEvent: false });
    }
  }

  private onFormChanges(): void {
    this.formGroup.get(this.numeroPagamentoName).valueChanges.subscribe(
      (numeroPagamento) => this.tratarPreenchimentoCampoPrincipal(numeroPagamento, "pagamento")
    );

    this.formGroup.get(this.numeroDocumentoName).valueChanges.subscribe(
      (numeroDocumento) => this.tratarPreenchimentoCampoPrincipal(numeroDocumento, "documento")
    );

    this.formGroup.get(this.cpfSemDvName).valueChanges.subscribe(
      (cpf) => this.tratarPreenchimentoNi(cpf, "cpf")
    );

    this.formGroup.get(this.cnpjSemDvName).valueChanges.subscribe(
      (cnpj) => this.tratarPreenchimentoNi(cnpj, "cnpj")
    );

    this.formGroup.get(this.condicaoDocumentoName).valueChanges.subscribe(
      () => this.condicaoDocumentoOnChange()
    );

    this.formGroup.get(this.bancoName).valueChanges.subscribe(
      (banco) => this.agenciaOnChange(banco)
    );

    this.formGroup.get(this.periodoFixoName).valueChanges.subscribe(
      (periodoEmAnos) => this.periodoFixoOnChange(periodoEmAnos)
    );

    this.formGroup.get(this.faixaInicioName).valueChanges.subscribe(
      () => this.tratarErroFaixaValores()
    );

    this.formGroup.get(this.faixaFimName).valueChanges.subscribe(
      () => this.tratarErroFaixaValores()
    );

    this.formGroup.get(this.dataArrecadacaoInicioName).valueChanges.subscribe(
      () => this.tratarErroFaixaDatas()
    );

    this.formGroup.get(this.dataArrecadacaoFimName).valueChanges.subscribe(
      () => this.tratarErroFaixaDatas()
    );

    this.formGroup.valueChanges.subscribe(() => this.tratarBloqueioOutrosCampos());
  }

  private tratarPreenchimentoCampoPrincipal(numero: string, campo: "documento" | "pagamento"): void {
    const camposNaoAfetados = campo === "pagamento" ? [this.numeroPagamentoName] : [this.numeroDocumentoName, this.condicaoDocumentoName];

    if (this.atendimento) {
      camposNaoAfetados.push(this.cpfSemDvName, this.cnpjSemDvName, this.niInvalidoName);
    }

    const camposAfetados = Object.keys(this.formGroup.controls).filter((campo) => !camposNaoAfetados.includes(campo));
    const isCampoPreenchido = numero?.length > 0;

    this.alterarBloqueioCampos(isCampoPreenchido ? "bloquear" : "desbloquear", camposAfetados);

    if (campo === "pagamento") {
      this.formGroup.get(this.condicaoDocumentoName).setValue(this.condicoesDocumentoArrecadacao[0]);
    }
  }

  private tratarPreenchimentoNi(valor: string, campo: "cnpj" | "cpf"): void {
    const camposAfetados = campo === "cnpj" ? [this.cpfSemDvName] : [this.cnpjSemDvName];
    const isCampoPreenchido = valor?.length > 0;

    this.alterarBloqueioCampos(isCampoPreenchido ? "bloquear" : "desbloquear", camposAfetados);
  }

  private tratarBloqueioOutrosCampos(): void {
    if (this.numeroDocumento != null || this.numeroPagamento != null) {
      return;
    }

    const isCondicaoPago = this.condicaoDocumento == null || this.condicaoDocumento.codigo === CondicaoDocumentoEnum.PAGO;
    this.alterarBloqueioCampos(!isCondicaoPago ? "bloquear" : "desbloquear", [this.bancoName, this.numeroPagamentoName], !isCondicaoPago);

    const isBancoPreenchido = this.banco != null;
    this.alterarBloqueioCampos(!isBancoPreenchido ? "bloquear" : "desbloquear", [this.agenciaName], !isBancoPreenchido);

    const tipoNivelPesquisa = this.formGroup.get(this.tipoPesquisaName).value as TipoNivelPesquisa;
    if (tipoNivelPesquisa === TipoNivelPesquisa.DELEGACIA) {
      this.alterarBloqueioCampos("desbloquear", [this.delegaciaName], false);
      this.alterarBloqueioCampos("bloquear", [this.regiaoName]);
    } else if (tipoNivelPesquisa === TipoNivelPesquisa.REGIAO) {
      this.alterarBloqueioCampos("desbloquear", [this.regiaoName], false);
      this.alterarBloqueioCampos("bloquear", [this.delegaciaName]);
    } else {
      this.alterarBloqueioCampos("bloquear", [this.delegaciaName, this.regiaoName]);
    }
  }

  private agenciaOnChange(banco: BancoDto): void {
    if (banco != null) {
      this.agencias$ = this.pagamentoService.obterAgencias(banco).pipe(this.customErrorHandler("Agência"))
    }
  }

  private condicaoDocumentoOnChange(): void {
    this.formGroup.get(this.naturezaDocumentoName).setValue(null, { emitEvent: false });
    this.formGroup.get(this.modalidadeArrecadacaoName).setValue(null, { emitEvent: false });
  }

  private obterPeriodoFixoInicial(periodoEmAnos: number): Date {
    return new Date(this.dataHoje.getFullYear() - periodoEmAnos, this.dataHoje.getMonth(), this.dataHoje.getDate());
  }

  public selecionarPeriodo(periodoEmAnos: number): void {
    if (!this.formGroup.get(this.periodoFixoName).enabled) {
      return;
    }

    if (this.periodoFixo === periodoEmAnos) {
      periodoEmAnos = null;
    }

    this.formGroup.get(this.periodoFixoName).setValue(periodoEmAnos);
  }

  private periodoFixoOnChange(periodoEmAnos: number): void {
    if (periodoEmAnos) {
      this.alterarBloqueioCampos("bloquear", [this.dataArrecadacaoInicioName, this.dataArrecadacaoFimName]);
      this.formGroup.get(this.dataArrecadacaoInicioName).setValue(this.obterPeriodoFixoInicial(periodoEmAnos));
      this.formGroup.get(this.dataArrecadacaoFimName).setValue(this.dataHoje);
    }
    else {
      this.alterarBloqueioCampos("desbloquear", [this.dataArrecadacaoInicioName, this.dataArrecadacaoFimName]);
    }
  }

  limparFormulario(): void {
    this.formGroup.reset();
    this.formGroup.get(this.condicaoDocumentoName).setValue(this.condicoesDocumentoArrecadacao[0]);
    this.preencherCpfOuCnpj();
  }

  public fecharModal(): void {
    this.modalRef.hide();
  }

  private camposNivelPesquisaEhInvalido(nivelPesquisa: NivelPesquisa): boolean {
    return (nivelPesquisa?.tipo === TipoNivelPesquisa.DELEGACIA || nivelPesquisa?.tipo === TipoNivelPesquisa.REGIAO) && !nivelPesquisa.valor;
  }

  private abrirModalErroNivelPesquisa(): void {
    this.modalRef = this.bsModalService.show(this.templateModalErro);
  }

  private alterarBloqueioCampos(acao: "bloquear" | "desbloquear", formsNames: string[], resetar: boolean = true, options: { emitEvent?: boolean } = { emitEvent: false }): void {
    formsNames.forEach(name => {
      const form = this.formGroup.get(name);

      if (acao === "bloquear") {
        form.disable(options);
      } else {
        form.enable(options);
      }

      if (resetar) {
        form.reset(null, options);
      }
    });
  }

  public get labelData(): string {
    if (this.isCondicaoDocumentoPago()) {
      return "Data de Arrecadação";
    }
    else if (this.isCondicaoDocumentoEmitido()) {
      return "Data de Emissão";
    }
    else {
      return "Data de Débito";
    }
  }

  public isCondicaoDocumentoPago(): boolean {
    return this.formGroup.get(this.condicaoDocumentoName).value?.codigo === CondicaoDocumentoEnum.PAGO;
  }

  public isCondicaoDocumentoEmitido(): boolean {
    return this.formGroup.get(this.condicaoDocumentoName).value?.codigo === CondicaoDocumentoEnum.EMITIDO;
  }

  private validarFaixaValores(): boolean {
    const faixaInicio = this.formGroup.get(this.faixaInicioName).value;
    const faixaFim = this.formGroup.get(this.faixaFimName).value;

    if (faixaInicio && faixaFim) {
      return faixaInicio <= faixaFim;
    }

    return true;
  }

  public tratarErroFaixaValores(): void {
    if (this.validarFaixaValores()) {
      this.formGroup.get(this.faixaInicioName).setErrors(null);
      this.formGroup.get(this.faixaFimName).setErrors(null);
    }
    else {
      this.formGroup.get(this.faixaInicioName).setErrors({ 'faixaInvalida': true });
      this.formGroup.get(this.faixaFimName).setErrors({ 'faixaInvalida': true });
    }
  }

  private validarFaixaDatas(): boolean {
    const dataInicio = this.formGroup.get(this.dataArrecadacaoInicioName).value;
    const dataFim = this.formGroup.get(this.dataArrecadacaoFimName).value;

    if (dataInicio && dataFim) {
      return new Date(dataInicio) <= new Date(dataFim);
    }

    return true;
  }

  public tratarErroFaixaDatas(): void {
    if (this.validarFaixaDatas()) {
      this.formGroup.get(this.dataArrecadacaoInicioName).setErrors(null);
      this.formGroup.get(this.dataArrecadacaoFimName).setErrors(null);
    } else {
      this.formGroup.get(this.dataArrecadacaoInicioName).setErrors({ 'faixaDataInvalida': true });
      this.formGroup.get(this.dataArrecadacaoFimName).setErrors({ 'faixaDataInvalida': true });
    }
  }

}
